import { LoanProgram } from '@frontend/pricing-search';
import { get } from 'lodash';
import Common from '../../common/services/Common';
import Session, { ALL_SUMMARY_PARAMS } from '../../common/services/Session';
import { convertLoanInfoToEPCModel } from '../../common/utils/loanDataUtil';
import {
  setFieldAccessRules,
  setLoanAccessRules,
  setPersonaAccessData,
} from './actions';

export const evaluateLoanAccessRules = async (loanId, loan) => {
  const response = await Common.evaluateLoanAccessRules(
    loanId,
    undefined,
    loan,
  );
  return response;
};

// The selected program drives the evaluator rules, so prefer it over the program
// already on the loan, which is only relevant for relock/lock update.
const resolveProgramName = (
  loanPrograms: LoanProgram[],
  programId?: number,
  relockProgramId?: number,
) => {
  const selectedProgramId = programId ?? relockProgramId;
  if (!selectedProgramId) return undefined;
  return (loanPrograms ?? []).find(
    ({ programID }) => programID === selectedProgramId,
  )?.program;
};

export const fetchCurrentPersonaAccessRules = () => async (dispatch, state) => {
  try {
    const loanData = get(state(), 'EPPS.originalLoanInformation') || {};
    const modifiedLoanData = get(state(), 'EPPS.loanInfo') || {};
    const loanProperties = get(state(), 'EPPS.loanProperties') || {};
    const loanPrograms = get(state(), 'EPPS.loanPrograms.loanPrograms', []);
    const { programId } = Session.get(ALL_SUMMARY_PARAMS) || {};
    const programName = resolveProgramName(
      loanPrograms,
      programId,
      get(state(), 'EPPS.loanInfo.relockRequest.specificProgramID'),
    );
    const emptyLoanData = convertLoanInfoToEPCModel(
      modifiedLoanData,
      loanProperties,
      programName,
    );
    // I need the guid which seems to be coming from customId
    const results = await evaluateLoanAccessRules(loanData.id, emptyLoanData);
    if (results) {
      dispatch(
        setPersonaAccessData(results.personaAccessToLoanActionRules || []),
      );
      dispatch(setFieldAccessRules(results.fieldAccessRules || []));
      dispatch(setLoanAccessRules(results.loanAccessRules || []));
    }
  } catch (e) {
    console.error(e);
  }
};
